import script from "./cardtypesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./cardtypesList.vue?vue&type=script&lang=ts&setup=true"

import "./cardtypesList.vue?vue&type=style&index=0&id=7508e883&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7508e883"]])

export default __exports__